import { EsRequestPetitions } from "@edp-models/ES/es-petitions.model";
import { EsRequestOperations, IEsRequestsOperationsFilter, IInterventionDateES } from "@edp-models/ES/es-request-operatios.model";
import { ServiceES } from "@edp-models/ES/es-service.model";
import { INewRequestAndOperationES } from "@edp-pages/ES/request-and-operations-es/services-es/new-request-es.service";

export interface IRequestsOperationsESState {
    eSrequestsAndOperations: EsRequestPetitions[];
    eSloadedRequestOperations: boolean;
    eSassociatedContract: number;
    eSfilters: IEsRequestsOperationsFilter[];
    eSlocalSupportList: boolean;
    eSloadedServices: boolean;
    eSservices: ServiceES[];
    eSloadedSlots: boolean;
    eSavailableTimeSlots: {
        data: IInterventionDateES[];
        lastAPIError: Error;
    };
    eSselectedRequest: EsRequestOperations;
    eSselectedServiceAndMotive: INewRequestAndOperationES;
    eSnewRequestStatus: any;
}

export const initialRequestOperationsESState: IRequestsOperationsESState = {
    eSrequestsAndOperations: [],
    eSloadedRequestOperations: false,
    eSassociatedContract: 0,
    eSfilters: [],
    eSlocalSupportList: true,
    eSloadedServices: false,
    eSservices: [],
    eSloadedSlots: false,
    eSavailableTimeSlots: {
        data: null,
        lastAPIError: null,
    },
    eSselectedRequest: null,
    eSselectedServiceAndMotive: null,
    eSnewRequestStatus: null,
};
